<template>
    <div class="card" :class="{'center-content': center}" v-if="visible">
        <div class="header" v-if="hasHeader()" :class="{'header-icon': icon != null}">
            <!-- Icon -->
            <span class="icon" v-if="icon" :class="icon"></span>

            <!-- Headline -->
            <div v-if="headline" class="headline pull-left" :class="{oneHeadline: !description}">
                {{headline | capitalize}}

                <!-- Description -->
                <p class="category" v-if="description">{{description}}</p>
            </div>

            <!-- Actions -->
            <div class="right">
                <slot name="header"></slot>
            </div>
        </div>

        <div class="clearfix"></div>

        <div :class="{'center-me': center}" class="content">
            <div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    $boxSpacing: 20px;

    .card {
        position: relative;
        padding: $boxSpacing / 2;
        width: 100%;

        border-radius: 4px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(63, 63, 68, 0.1);
        margin-bottom: 30px;

        background-color: #fff;

        .close {
            position: absolute;
            color: #000;
            right: 10px;
            top: 10px;
            opacity: .5;
            font-size: 18pt;
        }

        .header {
            display: flex;

            .right {
                margin-left: auto;
            }
        }

        .header-icon {
            .headline {
                font-size: 11pt;
            }

            .icon {
                float: left;
                font-size: 30px;
                margin-right: 10px;
            }

            > div {
                float: left;

                font-size: 11pt;
                font-weight: 400;
                margin-top: -4px;

                p {
                    font-size: 10pt;
                }
            }
        }

        .content {
            padding: $boxSpacing / 2;
        }

        .footer {
            padding: 10px 0 0 0;
            margin: 0;
        }

        .headline {
            &.oneHeadline {
                margin-top: 5px;
            }
        }

        hr {
            margin: 20px -20px;
        }

        &.center-content {
             width: 100%;
             justify-content: center;
             align-items: center;
             display: flex;
        }
    }
</style>

<script>
export default {
    props: {
        icon: {
            type: String
        },

        headline: {
            type: String
        },

        description: {
            type: String
        },

        close: {
            type: Boolean,
            default: false
        },

        center: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: true
        }
    },
    methods: {
        remove() {
            this.visible = false;
        },

        hasHeader() {
            return (this.icon || this.headline || this.description);
        }
    }
}
</script>


// WEBPACK FOOTER //
// Card.vue?59171575